import React from 'react';
import { withRouter } from '../util/withRouter';
import withStyles from '@mui/styles/withStyles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import cx from 'classnames';
import { applyUrlParams } from '../util/strings';
import ValidationBadges from './ValidationBadges';

function getTabPath(tab, props) {
    return applyUrlParams(tab.path, props.match.params);
}

class RouteTabs extends React.Component {
    state = {
        selectedIndex: 0
    };

    static getDerivedStateFromProps(newProps, oldState) {
        const { tabs, history, location, onChange } = newProps;
        let selectedIndex = tabs.findIndex(tab => location.pathname.startsWith(getTabPath(tab, newProps)));
        if (selectedIndex === -1) {
            // Redirect to the first tab path
            history.replace(getTabPath(tabs[0], newProps));
            selectedIndex = 0;
        }
        if (selectedIndex !== oldState.selectedIndex) {
            if (onChange) onChange(tabs[selectedIndex].label);
            return { selectedIndex };
        }
        return null;
    }

    onChange = (e, selectedIndex) => {
        const { history, tabs } = this.props;
        history.push(getTabPath(tabs[selectedIndex], this.props));
    };

    render() {
        const { classes, tabs, children } = this.props;
        const { selectedIndex } = this.state;

        return (
            <div style={{ position: 'relative' }}>
                <Tabs
                    value={selectedIndex}
                    TabIndicatorProps={{ component: 'indicator' }}
                    indicatorColor="primary"
                    variant="scrollable"
                    scrollButtons
                    className={classes.tabs}
                    classes={{
                        scrollButtonsAuto: classes.scrollButtons,
                        flexContainer: classes.tabsContainer,
                        scroller: classes.scroller
                    }}
                    onChange={this.onChange}
                    allowScrollButtonsMobile
                >
                    {tabs.map(this.renderTab)}
                </Tabs>
                {children(selectedIndex)}
            </div>
        );
    }

    renderTab = (tab, index) => {
        const { classes } = this.props;
        return (
            <Tab
                key={tab.key}
                tab={tab.key}
                label={this.renderTabLabel(tab, index === this.state.selectedIndex)}
                className={classes.tab}
            />
        );
    };

    renderTabLabel(tab, selected) {
        const { classes } = this.props;

        return (
            <div className={classes.tabContainer}>
                <div className={selected ? cx(classes.tabLabel, classes.tabLabelSelected) : classes.tabLabel}>
                    {tab.title || tab.label}
                    <ValidationBadges tabID={tab.key} />
                </div>
            </div>
        );
    }
}

// We don't want the browser scroll bar to be visible when scrolling the tabs
// so we increase the height of the tabs scroller div so the scroll bar is hidden
const browserScrollBarOffset = 32;

const styles = ({ palette, typography, sizes, funeralHome }) => ({
    tabContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    tabs: {
        borderBottom: `1px solid ${palette.divider}`,
        height: sizes.tabHeight
    },
    tabsContainer: {
        height: sizes.tabHeight
    },
    tab: {
        height: sizes.tabHeight
    },
    scrollButtons: {
        flex: '0 0 40px'
    },
    scroller: {
        height: sizes.tabHeight + browserScrollBarOffset,
        '& > :last-child': {
            top: sizes.tabHeight - 3
        }
    },
    tabLabel: {
        display: 'flex',
        whiteSpace: 'pre',
        textTransform: 'none',
        ...typography.subtitle2
    },
    tabLabelSelected: {
        fontWeight: typography.fontWeightMedium,
        color: palette.contentForeground[funeralHome],
        border: `1px solid ${palette.contentBackground[funeralHome]}CC`,
        background: palette.contentBackground[funeralHome] + 33,
        padding: '4px 12px',
        borderRadius: 10
    }
});

export default withRouter(withStyles(styles)(RouteTabs));
